module.exports = __webpack_public_path__ + "static/media/2.eed2d4a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/PhuketSkypark/sitePlan/svg/c/2.png
// module id = 976
// module chunks = 0